<router-outlet></router-outlet>
<ui-spinner></ui-spinner>